import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { Modal, Icon } from '@components/shared/elements'
import MaskedInput from 'react-text-mask'

import TOOLS from '@helpers/tools'
import COOKIES from '@helpers/cookies'
import { handleBlurDatalayer } from '@helpers/BI'
import slugify from 'slugify'
import { isEmpty } from 'lodash'

class ModalObra extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      phone: '',
      city: '',
      message: '',
      nameDirt: false,
      emailDirt: false,
      phoneDirt: false,
      cityDirt: false,
      messageDirt: false,
      blockSending: false,
      success: '',
      error: '',
    }
    this.el = React.createRef()
  }


  _enviaMensagem(element) {
    let region = undefined
    const elementText = slugify(element.target.innerText, { lower: true })

    if (this.props.region === undefined) {
      region = 'n/a'
    } else {
      region = this.props.region
    }

    const gaSend = COOKIES.getUtmGaSend()

    this.setState({ blockSending: true })
    let jsonBody = {}

    jsonBody['webform_id'] = 'meu_vivaz_vizinho_de_obra'
    jsonBody['email'] = this.state.email
    jsonBody['nome'] = this.state.name
    jsonBody['telefone'] = this.state.phone
    jsonBody['cidade'] = this.state.city
    jsonBody['mensagem'] = this.state.message
    jsonBody['praca'] = region
    jsonBody['imovel_origem_id'] = 3
    jsonBody['ponto_contato'] = 'Sou vizinho de uma obra'
    jsonBody['url'] = window.location.href
    jsonBody['codigo_ga'] = gaSend.CodigoGa

    Object.assign(jsonBody, gaSend)

    this.props.actions.contactUsNeighbour(jsonBody).then((result) => {
      if (!isEmpty(result.sid)) {
        jsonBody.retorno = result.IdLead
        this.setState({
          nameDirt: false,
          emailDirt: false,
          success: true,
          error: false,
        })
        setTimeout(() => {
          this.props.close()
        }, 5000)
      } else {
        this.setState({
          success: false,
          error: true,
        })
      }
    }).finally(() => {
      setTimeout(() => {
        this.setState({
          blockSending: false,
          success: false,
          error: false,
        })
      }, 5000)
    })

    // GA data
    let dataLayer = window['dataLayer']

    if (dataLayer && (!isEmpty(jsonBody))) {
      let ecommerce = {
        purchase: {
          actionField: {
            id: `${jsonBody.retorno}`,
          },
          products: {
            id: 'na',
            name: 'na',
            brand: 'vivaz',
            category: 'na',
            variant: 'na',
            price: 1,
          },
        },
      }
      dataLayer.push({
        'event': 'purchase',
        'eventCategory': 'form-contato',
        'eventAction': `${elementText}:submit`,
        'eventLabel': `footer:email:${elementText}:${jsonBody.retorno}`,
        ecommerce,
      })
    }
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value,
    })
  }
  render() {
    let nameValid
    let emailValid
    let phoneValid
    let cityValid
    let messageValid
    let blockSending = this.state.blockSending

    if (this.state.nameDirt) {
      nameValid = (this.state.name !== '') ? 'is-valid' : 'has-error'
    }

    if (this.state.emailDirt) {
      emailValid = (TOOLS.emailValid(this.state.email)) ? 'is-valid' : 'has-error'
    }

    if (this.state.phoneDirt) {
      phoneValid = (TOOLS.phoneValid(this.state.phone)) ? 'is-valid' : 'has-error'
    }

    if (this.state.cityDirt) {
      cityValid = (this.state.city !== '') ? 'is-valid' : 'has-error'
    }
    if (this.state.messageDirt) {
      messageValid = (this.state.message !== '') ? 'is-valid' : 'has-error'
    }

    return <Modal show={this.props.show} close={this.props.close} fullscreen={false} goback={this.props.goback}>
      <h4 className='h5 mt3 mb2'><strong>Sou vizinho de uma obra</strong></h4>
      <p>Tem alguma dúvida ou sugestão e quer falar com a gente?</p>
      <p>Deixe sua mensagem abaixo, vamos retornar logo, logo</p>
      <form onSubmit={(event) => this._handleSubmit(event)} ref={this.el} data-ga-name='modal-obra'>

        <div className={`field-group mb2 ${nameValid === 'is-valid' && 'is-valid'} ${nameValid === 'has-error' && 'has-error'}`}>
          <label>
            <input className='mb0' type='text' value={this.state.name} onChange={(event) => this.setState({ name: event.target.value })} onBlur={(e) => { handleBlurDatalayer(e, 'name', 'Sou vizinho de uma obra'); this.setState({ nameDirt: true }) }} placeholder='Qual é seu nome?' maxLength='70' />
            <div className='text-small text-error ml1 mt1'>Qual seu nome?</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon iconType='far' icon='user' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>
        <div className={`field-group mb2 ${emailValid === 'is-valid' && 'is-valid'} ${emailValid === 'has-error' && 'has-error'}`}>
          <label>
            <input
              className='mb0'
              type='email'
              value={this.state.email}
              onChange={(event) => this.setState({ email: event.target.value })}
              onBlur={(e) => { handleBlurDatalayer(e, 'email', 'Sou vizinho de uma obra'); this.setState({ emailDirt: true }) }}
              maxLength='70'
              placeholder='Qual é seu e-mail?'
            />
            <div className='text-small text-error ml1 mt1'>Seu e-mail</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon icon='at' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>
        <div className={`field-group mb3 ${phoneValid === 'is-valid' && 'is-valid'} ${phoneValid === 'has-error' && 'has-error'}`}>
          <label>
            <MaskedInput
              mask={TOOLS.cellphoneMask(this.state.phone)}
              guide={false}
              className='mb0'
              type='tel'
              value={this.state.phone}
              onChange={(event) => this.setState({ phone: event.target.value })}
              onBlur={(e) => { handleBlurDatalayer(e, 'phone', 'Sou vizinho de uma obra'); this.setState({ phoneDirt: true }) }}
              placeholder='Qual é o seu telefone (com DDD)?'
            />
            <div className='text-small text-error ml1 mt1'>Seu telefone com DDD</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon icon='phone' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>
        <div className={`field-group mb2 ${cityValid === 'is-valid' && 'is-valid'} ${cityValid === 'has-error' && 'has-error'}`}>
          <label>
            <input className='mb0' type='text' value={this.state.city} onChange={(event) => this.setState({ city: event.target.value })} onBlur={(e) => { handleBlurDatalayer(e, 'city', 'Sou vizinho de uma obra'); this.setState({ cityDirt: true }) }} placeholder='Qual é a sua cidade?' maxLength='70' />
            <div className='text-small text-error ml1 mt1'>Qual é a sua cidade?</div>
          </label>
        </div>
        <div className={`field-group mb2 ${messageValid === 'is-valid' && 'is-valid'} ${messageValid === 'has-error' && 'has-error'}`}>
          <label>
            <input className='mb0' type='text' value={this.state.message} onChange={(event) => this.setState({ message: event.target.value })} onBlur={(e) => { handleBlurDatalayer(e, 'message', 'Sou vizinho de uma obra'); this.setState({ messageDirt: true }) }} placeholder='Mensagem' maxLength='70' />
            <div className='text-small text-error ml1 mt1'>Mensagem</div>
          </label>
        </div>

        <button className='button info min-width mt4' type='button' disabled={blockSending} onClick={e => this._enviaMensagem(e)} data-ga-status>{blockSending ? 'Enviando...' : 'Solicitar informações'}</button>

        {this.state.success &&
          <div className='callout success text-center mt4 mb0'>
            <p>Suas informações foram enviadas com sucesso.</p>
          </div>
        }
        {this.state.error &&
          <div className='callout alert text-center mt4 mb0'>
            <p>Não foi possível realizar a sua solicitação, tente mais tarde.</p>
          </div>
        }
      </form>
    </Modal>
  }
}
const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    region: state.shared.region,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...USER_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalObra)



// WEBPACK FOOTER //
// ./src/components/children/contactForm/ModalObra.js